import axiosClient from './axiosClient';
import { TicketMandatoryFieldModel } from '../Models/ticketMandatoryFieldModel';

const ticketMandatoryFieldService = {
  getAll: () => {
    return axiosClient.get('/TicketMandatoryField')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /TicketMandatoryField returned 404. Falling back to GET /ticket-mandatory-fields...");
          return axiosClient.get('/ticket-mandatory-fields');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(TicketMandatoryFieldModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (mandatoryFieldID) => {
    return axiosClient.get(`/TicketMandatoryField/${mandatoryFieldID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /TicketMandatoryField/${mandatoryFieldID} returned 404. Falling back to GET /ticket-mandatory-fields/${mandatoryFieldID}...`);
          return axiosClient.get(`/ticket-mandatory-fields/${mandatoryFieldID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketMandatoryFieldModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = TicketMandatoryFieldModel.toBackend(payload);
    body.mandatoryFieldId = 0;

    return axiosClient.post('/TicketMandatoryField', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketMandatoryField returned 404. Falling back to POST /ticket-mandatory-fields...");
          return axiosClient.post('/ticket-mandatory-fields', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketMandatoryFieldModel.toFrontend(raw),
        };
      });
  },

  update: (mandatoryFieldID, payload) => {
    const body = TicketMandatoryFieldModel.toBackend({ ...payload, mandatoryFieldID });

    return axiosClient.put('/TicketMandatoryField', body)
      .catch((err) => {
        if (err?.response?.status === 404 || err?.response?.status === 405) {
          return axiosClient.put(`/TicketMandatoryField/${mandatoryFieldID}`, body);
        }
        return Promise.reject(err);
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          return axiosClient.put('/ticket-mandatory-fields', body);
        }
        return Promise.reject(err);
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          return axiosClient.put(`/ticket-mandatory-fields/${mandatoryFieldID}`, body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketMandatoryFieldModel.toFrontend(raw),
        };
      });
  },

  remove: (mandatoryFieldID) => {
    return axiosClient.delete(`/TicketMandatoryField/${mandatoryFieldID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketMandatoryField/${mandatoryFieldID} returned 404. Falling back to DELETE /ticket-mandatory-fields/${mandatoryFieldID}...`);
          return axiosClient.delete(`/ticket-mandatory-fields/${mandatoryFieldID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default ticketMandatoryFieldService;
